module.exports = __webpack_public_path__ + "static/media/course1.ac9b6691.jpg";